import { useState } from 'react';
// import { useLocation } from 'react-router';
import { Paper, Stack } from '@mui/material';
import { useAuth } from 'providers/AuthProvider';
import CandidateInfo from '../../components/SS/CandidateInfo';
import ProfileHeader from '../../components/SS/ProfileHeader';
import CandidateDetailsMain from '../../components/SS/main';

const UserInfo = () => {
  const { sessionUser } = useAuth();
  const [candidate, setCandidate] = useState(sessionUser);

  return (
    <Stack direction="column" height={1}>
      <ProfileHeader
        candidate={candidate}
        setCandidate={setCandidate}
        profile={true}
        account={true}
        team={true}
      />

      <Stack direction={{ xs: 'column', md: 'row' }} sx={{ height: 1 }}>
        <Paper background={1} sx={{ width: { md: 300, xl: 360 }, p: { xs: 3, lg: 5 } }}>
          <CandidateInfo
            contact={{
              email: sessionUser.email,
              phone: sessionUser.mobile,
              address: sessionUser.currentAddress,
            }}
            previous={{
              prevCTC: sessionUser.prevCTC,
              prevCompany: sessionUser.prevCompany,
              noticePeriod: sessionUser.noticePeriod,
            }}
            address={{
              currentAddress: sessionUser.currentAddress,
              permanentAddress: sessionUser.permanentAddress,
            }}
            experiences={{ qualification: sessionUser.qualification }}
            // education={candidateInfo.education}
          />
        </Paper>

        <Paper sx={{ flex: 1, p: { xs: 3, lg: 5 } }}>
          <CandidateDetailsMain state={sessionUser} profile={true} />
        </Paper>
      </Stack>
    </Stack>
  );
};

export default UserInfo;
